export default __webpack_public_path__ + "static/media/HTC Nexus 9.9fc3f8e9.png";